<div class="dialog-heading">
  <h5>{{title}}</h5>
  <span style="flex: 1 1 auto"></span>
  <mat-icon class="closeDialog" aria-hidden="false" [mat-dialog-close]="{ success: false }" aria-label="Close icon">close</mat-icon>
</div>

<div>
  <div class="description" *ngIf="description?.length > 0">{{description}}</div>
  <div>
    <ul class="messageList" *ngIf="messages?.length > 0">
      <li *ngFor="let m of messages">{{m}}</li>
    </ul>
  </div>

  <div *ngIf="radioTxts.length > 0" class="radioGroup">
    <mat-radio-group aria-label="Select an option">
      <mat-radio-button style="display: block" id="radio0" (change)="onRadioChanged(false)" value="{{radioTxts[0]}}" checked>{{radioTxts[0]}}</mat-radio-button>
      <mat-radio-button id="radio1" (change)="onRadioChanged(true)" value="{{radioTxts[1]}}">{{radioTxts[1]}}</mat-radio-button>
    </mat-radio-group>
  </div>

  <app-upload
    *ngIf="radioTxts.length === 0 || !hideUpload"
    id="consumption-upload"
    (after-closed)="onCompleteUpload($event)"
    (on-error)="onUploadError($event)"
    (on-upload-start)="parsingErrorMessages = []"
    [fileTypes]="['csv', 'xlsx']"
    [upload-url]="'file/parse'"
    [additionalData]="parseRequestData"
    [document-type]="'ConsumptionData'"
    [multiple]="false"
    [upload-description]="'Drag and drop your usage data files here'"
  ></app-upload>

  <div *ngIf="consumptionFile">
    <ul class="file-list">
      <li>
        <div class="delete-file">
          <a class="download-link" appDownloadLink [file]="consumptionFile">{{ consumptionFile?.data.fileName }}</a>
          <app-delete-file [file]="consumptionFile" (after-delete)="onDeleteUpload()" [showConfirmation]="false"> </app-delete-file>
        </div>
      </li>
    </ul>
  </div>

  <div class="upload-status-box" *ngIf="!hideUpload">
    <p style="color: red" *ngFor="let errMessage of getParsingErrorMessages()">
      <img src="../../../../assets/icons/icon_error.svg" class="icon-sm" aria-hidden="false" aria-label="Parsing error" /> {{errMessage}}
    </p>
  </div>

  <div class="dialog-actions">
    <span style="flex: 1 1 auto"></span>
    <button class="okBtn" mat-flat-button color="accent" type="button" (click)="closeDialog(hideUpload)">Ok</button>
    <button mat-stroked-button color="accent" [mat-dialog-close]="{ confirmed: false }">Cancel</button>
  </div>
</div>
